import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M633.355 512l339.75-339.75c15.227-15.475 24.633-36.723 24.633-60.17 0-47.388-38.415-85.804-85.804-85.804-23.451 0-44.703 9.407-60.195 24.657l-339.737 339.709-339.75-339.724c-15.626-16.162-37.499-26.196-61.716-26.196-47.388 0-85.804 38.415-85.804 85.804 0 24.217 10.033 46.093 26.167 61.694l339.744 339.774-339.724 339.75c-16.162 15.626-26.196 37.499-26.196 61.716 0 47.388 38.415 85.804 85.804 85.804 24.217 0 46.093-10.033 61.694-26.167l339.774-339.744 339.75 339.75c15.475 15.227 36.723 24.633 60.17 24.633 47.388 0 85.804-38.415 85.804-85.804 0-23.451-9.407-44.703-24.657-60.195l-339.709-339.737z\" p-id=\"6758\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/global/close.svg
// module id = a+g5
// module chunks = 55